import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";

function CenterDoctorNavbar({ setSearchModal }) {
  const [isSticky, setIsSticky] = useState(false);
  const patientLogin = useSelector((state) => state.patient.patientLogin);
  const sitedata = useSelector((store) => store.global.loginData);

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 0) {
        setIsSticky(true);
      } else {
        setIsSticky(false);
      }
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  return (
    <div className="sticky-outer full-dark">
      <div className={`sticky-head ${isSticky ? "header-sticky" : ""}`}>
        <nav className="navbar">
          <div className="basic-container clearfix">
            {/* Logo centered at the top */}
            <div className="text-center">
              <Link
                to={"/"}
                className="logo-general d-inline-flex align-items-center gap-1"
              >
                <img
                  src={
                    sitedata?.site_logo
                      ? `${sitedata?.site_logo}`
                      : "/assets/img/hospital-static.jpg"
                  }
                  alt="Logo"
                  style={{
                    width: "60px",
                    height: "60px",
                    borderRadius: "10px",
                  }}
                />
                <h5 className="mb-0">
                  {sitedata.site_type !== "hospitals" && sitedata?.site_title ? (
                        <span>{sitedata.site_title}</span>
                      ) : (
                        sitedata?.site_title || ""
                      )}
                </h5>
              </Link>
            </div>

            {/* Navigation links and login button centered on second line */}
            <div className="navbar-inner center-header-navlinks-hover">
              <ul className="nav navbar-items d-flex justify-content-center">
                <li className="list-item">
                  <ul className="nav navbar-main theme-main-menu d-flex flex-wrap justify-content-center">
                    <li className="menu-item">
                      <Link to={"/"}>Home</Link>
                    </li>
                    <li className="menu-item">
                      <Link to={"/about"}>About Me</Link>
                    </li>
                    <li className="dropdown menu-item dropdown-sub">
                      <a>Patient Care</a>
                      <ul className="dropdown-menu">
                        <li>
                          <Link to={"/hospital-clinic/0"}>Hospital/Clinic</Link>
                          <Link to={"/services"}>Services</Link>
                        </li>
                      </ul>
                    </li>
                    <li className="dropdown menu-item dropdown-sub">
                      <a>Media</a>
                      <ul className="dropdown-menu">
                        <li>
                          <Link to={"/blogs"}>Blogs</Link>
                          <Link to={"/news"}>News & Update</Link>
                          {sitedata?.permissions?.review !== "hide" && (
                            <Link to={"/reviews"}>Reviews</Link>
                          )}
                          <Link to={"/gallery"}>Gallery</Link>
                        </li>
                      </ul>
                    </li>
                    <li className="menu-item">
                      <Link to={"/contact"}>Contact Us</Link>
                    </li>
                  </ul>
                </li>
                <li className="list-item Login-btn-new-theme ms-3">
                  {patientLogin ? (
                    <Link to="/patient">My Account</Link>
                  ) : (
                    <Link to="/login">Login</Link>
                  )}
                </li>
              </ul>
            </div>
          </div>
        </nav>
      </div>
    </div>
  );
}

export default CenterDoctorNavbar;